import { PluginViewStateAdapter } from 'owa-editor';
import { ComposePluginViewState, ComposeViewState, getStore } from 'owa-mail-compose-store';

export type ComposeViewStateAdapter = () => ComposeViewState;

// Use this instead of the originalViewState as parameters on plugins that
// require knowing the current view state at the time it is called (VSO 54506)
export function createPluginViewStateAdapter(
    originalViewState: ComposeViewState
): ComposeViewStateAdapter;

export function createPluginViewStateAdapter<PluginName extends keyof ComposePluginViewState>(
    originalViewState: ComposeViewState,
    name: PluginName
): PluginViewStateAdapter<ComposePluginViewState[PluginName]>;

export function createPluginViewStateAdapter<PluginName extends keyof ComposePluginViewState>(
    originalViewState: ComposeViewState,
    name?: PluginName
): () => ComposePluginViewState[PluginName] | ComposeViewState {
    return () => {
        // Get the current compose view state using the initial view state's
        // compose ID, or else the initial view state itself if it has yet to
        // be placed in the store
        // Then retrieve the current plugin view state from the compose view state
        const composeStore = getStore();
        const viewState = composeStore.viewStates.get(originalViewState.composeId);
        const currentViewState = viewState || originalViewState;
        return name ? currentViewState[name] : currentViewState;
    };
}
